module.exports = __webpack_public_path__ + "static/stepper-silver-icon-ja-e4076a5ec3e451aca43af648ae591291.svg";